/* These functions make sure WordPress and Foundation play nice together. */
jQuery(document).ready(function() {
	// Remove empty P tags created by WP inside of Accordion and Orbit
	//jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// Block: "Read More" Toggle Buttons
	var instance = [ '1', '2', '3' ];
	jQuery.each( instance, function( i, val ) {
		jQuery('.toggle-' + val).click(function(e){
			e.preventDefault();
			jQuery('.showHide-' + val).slideToggle();
			jQuery(this).text( jQuery(this).text() == 'Read More' ? "Read Less" : "Read More");
		});
	});

	// OLD BLOCK: Service Metrics -- This is still in progress... needs to NOT fire until element is visible on page
	jQuery('.count-up > .metric-count').each(function () {
		jQuery(this).prop('Counter',0).animate({
			Counter: jQuery(this).text()
		}, {
			duration: 3300,
			easing: 'swing',
			step: function (now) {
				jQuery(this).text(Math.ceil(now));
			}
		});
	});

	//Notification Banner with close option 
	jQuery(".close-notification").click(function(){
		jQuery(".notification-bar").hide();
	}); 

	/* Block: Insurance Personas (3) */
	jQuery(function () {
		initHoverBoxes();
	});
	function initHoverBoxes() {
		var $column = jQuery('.insurance-personas-section .column');
		$column.mouseenter(function() {
			$column.removeClass('wide');
			$column.css('width', '16.666%');
			jQuery('.persona-title').css('bottom', '-150px');
			jQuery(this).addClass('wide');
		});
		$column.mouseleave(function() {
			$column.css('width', '33.333%');
			jQuery('.persona-title').css('bottom', '40px');
			$column.removeClass('wide');
		});
	}

	/* Handles buttons/links triggering modals*/
	jQuery('.immediate-response').attr('data-toggle', 'modalImmediateResponse');
	jQuery('.assign-a-claim').attr('data-toggle', 'modalAssignClaim');
	jQuery('.free-quote').attr('data-toggle', 'modalFreeQuote');

	/* Sitemap Page Updates */
	if(window.location.href.match('/sitemap')) {
        jQuery('body').addClass('sitemap-page');
		jQuery('body.sitemap-page #content').prepend('<h1>Sitemap</h1>');
    }
	
});
